export default function Industries() {
  const industries = [
    {
      title: 'Managed Service Providers (MSPs)',
      description: 'Scalable field support for deployment projects and client rollouts',
      icon: 'ri-server-line'
    },
    {
      title: 'Corporate Offices',
      description: 'Enterprise workstation deployments and infrastructure installations',
      icon: 'ri-building-line'
    },
    {
      title: 'Financial Services',
      description: 'Secure, compliant IT infrastructure deployment and cabling',
      icon: 'ri-bank-line'
    },
    {
      title: 'Legal & Professional Firms',
      description: 'Professional office IT setups and technology relocations',
      icon: 'ri-briefcase-line'
    },
    {
      title: 'Technology Companies',
      description: 'Rapid deployment support for growing tech organizations',
      icon: 'ri-code-box-line'
    }
  ];

  return (
    <section id="industries-section" className="py-20 bg-zinc-900">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-white mb-16">
          Industries Served
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {industries.map((industry, index) => (
            <div 
              key={index}
              className="bg-zinc-950 rounded-lg p-8 border border-zinc-800 hover:border-orange-500/30 transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500/10 rounded-lg mb-6">
                <i className={`${industry.icon} text-3xl text-orange-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">
                {industry.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {industry.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}